// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3xnIV","wrapper-nopadding":"wrapper-nopadding__1kW2n","loading":"loading__3_Kuf","error":"error__1qTNP","table-loading":"table-loading__1kKNR","empty-val":"empty-val__1iP5S","panelheader-tools":"panelheader-tools__1PdOA","propsPanels":"propsPanels__3nG4_","new":"new__2iiyQ","marginLm":"marginLm__3pYP3","marginRm":"marginRm__2umHW","fullWidth":"fullWidth__12ZR5","fullHeight":"fullHeight__1dcnI","noData":"noData__3zs7K","ota":"ota__2CYU1","panels":"panels__3z3jc"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayTOAStat/styles.scss
// module id = 2271
// module chunks = 1